import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { Router } from '@angular/router';
import { CommonService } from '../../shared/common.service';
import { CircleService } from '../circles/circle.service';


@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {
  ChangePasswordForm:FormGroup;
  isLoading:boolean = false;
  show: boolean = false;
  isLower: Boolean = true;
  isUpper: boolean = true;
  isLength:boolean = true;
  isSpecial:boolean = true;
  isSecure:boolean =false;
  constructor(    private fb: FormBuilder,
    private commonService: CommonService,
    private circleService:CircleService,
    private router:Router,
    private _snackBar: MatSnackBar,) { }

    ngOnInit() {
      this.initialiseForms();
    }

    initialiseForms() {
      this.ChangePasswordForm = this.fb.group({
        oldPassword: ["", [Validators.required,Validators.minLength(6)]],
        newPassword: ["", [Validators.required, Validators.minLength(8)]],
      });
    }

    password() {
      this.show = !this.show;
    }

    

    submitForm() {
      let req = this.ChangePasswordForm.value;
      this.isLoading = true;
      this.circleService.changePassword(req).subscribe((res) => {
        this.isLoading = false;
         if(res['message'] =='Success') {
         this.isLoading = false;
         this.ChangePasswordForm.reset();
         this._snackBar.open("Password changed successfully!!","",{
          duration: 3000,
          horizontalPosition:'right',
          verticalPosition:'top',
          panelClass: ['failure']
        });
        this.commonService.logOut();
         } 
       }, err => {
         this.isLoading = false;
       });
    }

    navBack () {
      this.router.navigate(["/main/dashboard/event/discussion-board"])
    }

    getPassword() {
      let password = this.ChangePasswordForm.value.newPassword;
  
      if(password.length < 2) {
        this.isUpper = true;
        this.isLower = true;
        this.isLength = true;
        this.isSpecial = true;
        return
      }
      if(password.length > 7) {
        this.isLength = true;
      }else {
        this.isLength = false;
      }
      
  
  
      if (password.match("[a-z]")) {
        this.isLower = true;
      } else {
        this.isLower = false;
      }
      if (password.match("[a-z]")) {
        this.isLower = true;
      } else {
        this.isLower = false;
      }
      if (password.match("[A-Z]")) {
        this.isUpper = true;
      }
      else {
        this.isUpper = false;
      }
      if(password.match("[#$^%,!&@_\.-]")){
        this.isSpecial = true;
      }else {
        this.isSpecial = false;
      }
      
      if (this.isLower == true && this.isUpper == true && this.isLength == true && this.isSpecial == true) {
        this.isSecure = true;
  
      } else {
        this.isSecure = false;
      }
  
    }

}
